module.exports = __webpack_public_path__ + "img/20191130133307770.577b6e4f.jpg";